module.exports = __webpack_public_path__ + "img/THH.bbab4918.jpg";